const { v4: uuidv4, v1 } = require('uuid');
const Utils = require('./Utils');

let isCookieSet = false;
// validation keys saved in local storage
const storageKeys = [
    { 'info-texts': uuidv4() },
    { 'reels': uuidv4() },
    { 'timer._': uuidv4() }
];
const browserName = Utils.getBrowser().name;
const divider = '=#';

module.exports = function Fingerprint() {
    const CACHED_FINGERPRINT_KEY = '#rtg_t@ken::user_f1ng@rpr1nt';
    const FINGERPRINT_KEY = '::_sounds.';
    // legacy fingerprint key
    let cachedFingerprint = localStorage.getItem(CACHED_FINGERPRINT_KEY);
    // currently used fingerprint key
    let fingerprint = localStorage.getItem(FINGERPRINT_KEY);

    // fingerprint could be already encrypted or in plain form
    if (fingerprint) {
        // if it's encrypted we have to decrypt it first
        const decrypted = Utils.decrypt(FINGERPRINT_KEY, fingerprint);
        fingerprint = decrypted.includes(divider) ? decrypted : fingerprint;
    } else {
        // if there isn't previously saved fingerprint, we create a new one
        fingerprint = uuidv4();
    }

    if (cachedFingerprint) {
        fingerprint = cachedFingerprint;
        localStorage.removeItem(CACHED_FINGERPRINT_KEY);
    }

    if (fingerprint.includes(divider)) {
        // extract all fingerprint parts for validation
        const fingerprintArr = fingerprint.split(divider);
        let keysValid = true;

        for (let i = 0; i < storageKeys.length; i++) {
            const key = Object.keys(storageKeys[i])[0];
            const val = localStorage.getItem(key) || uuidv4();
            storageKeys[i][key] = val;
            // first two elements of the fingerprintArr are the plain fingerprint and the browser name.
            // we need the rest of them - [i + 2]
            if (val !== fingerprintArr[i + 2]) {
                keysValid = false;
            }
        }
        // check if fingerprint includes the name of the current browser and the validation keys stored in local
        // storage match the ones included in fingerprint
        if (fingerprintArr[1] !== browserName || !keysValid) {
            fingerprint = uuidv4();
        } else {
            fingerprint = fingerprintArr[0];
        }
    }
    // the fingerprint that we store in local storage is combination from the fingerprint itself, browser name
    // and all the validation keys
    let storageFingerprint = `${fingerprint}${divider}${browserName}${divider}${storageKeys.reduce((acc, obj) => [...acc, Object.values(obj).map(val => val)], []).join(divider)}`;

    if (!localStorage.getItem(FINGERPRINT_KEY)) {
        localStorage.setItem(FINGERPRINT_KEY, Utils.crypt(FINGERPRINT_KEY, storageFingerprint));
    }

    // store validation keys in local storage
    storageKeys.forEach(el => {
        const key = Object.keys(el)[0];
        const val = el[key];
        if (!localStorage.getItem(key)) {
            localStorage.setItem(key, val);
        }
    });
    // this cookie does nothing - used for delusion:)
    if (!isCookieSet) {
        const userId = v1() + uuidv4();
        document.cookie = `userId=${userId}`;
        isCookieSet = true;
    }

    return fingerprint;
};
